export default {
  bars: [
    {
      name: '关于大会',
      id: '#theme'
    },
    {
      name: '精选课',
      id: '#course'
    },
    {
      name: '新闻速递',
      id: '#news'
    },
    {
      name: '精选视频',
      id: '#video'
    }
  ],

  banner: [
    {
      img: 'https://static001-test.geekbang.org/resource/image/2f/c6/2fcd6dbf9f51f4f58e8yyb01b91bebc6.png',
      imgM: 'https://static001.geekbang.org/resource/image/f0/2c/f01acd0e8f05yy9121b058e3c5f7022c.png',
      link: '/'
    },
    {
      img: 'https://static001.geekbang.org/resource/image/45/95/45d76c21e95505e31fa4fbbfff715895.jpg',
      imgM: 'https://static001.geekbang.org/resource/image/a6/56/a67c4ec228fdae4086b8ae67be364d56.jpeg',
      link: 'http://cloudonair.vhall.com/live/detail/id/140.html'
    },
    {
      img: 'https://static001.geekbang.org/resource/image/13/a6/135bae70dfe3e2bb60775b67yy3b2fa6.jpg',
      imgM: 'https://static001.geekbang.org/resource/image/2a/49/2aea3876f53068fdcdf171297d4c7b49.jpeg',
      link: 'http://cloudonair.vhall.com/live/detail/id/141.html'
    },
    {
      img: 'https://static001.geekbang.org/resource/image/7y/bc/7yyfc06254e7881f11f7128184b16ebc.jpg',
      imgM: 'https://static001.geekbang.org/resource/image/18/c7/1840a9c5db34ba109ae3dc6965888ec7.jpeg',
      link: 'http://cloudonair.vhall.com/live/detail/id/142.html'
    }
  ],

  theme: {
    title: 'Google Cloud Next ’20: OnAir',
    subtitle: '九大主题带给你非凡的技术视听盛宴',
    info: '北京时间7月15日，一年一度的 Google Cloud Next ’20: OnAir 如期在云端召开。此次大会从线下转到线上，为广大云技术爱好者、开发者和合作伙伴推出为期九周的精彩内容 —— 别具前瞻性的行业洞察，独具创新性的云端技术，最具参考性的领先实践……让您足不出户就能体验前沿科技！',
    link: 'https://www.bilibili.com/video/BV1t54y1S7t5?p=1&share_medium=android&share_plat=android&share_source=COPY&share_tag=s_i&timestamp=1598014529&unique_k=Vd7LQP',
    // videobg: 'https://static001.geekbang.org/resource/image/5c/3e/5c6d76817ae1e248bdf30c0415f2d13e.png',
    videobgM: 'https://static001.geekbang.org/resource/image/3f/92/3fcfc54806ac5708eb69f82de7515092.png',
    videobgPerson: 'https://static001.geekbang.org/resource/image/90/22/90d59c02e5876a2c6ed24a5b1b790822.jpg'
  },

  selectedCourse: {
    title: 'Google Cloud Next ’20 精选课',
    subtitle: '为中国客户精心打造的系列精选课程',
    info: `为让中国用户汲取大会的精华，助力中国企业扬帆出海、智赢全球，我们从大会的相关内容中精选出中国客户比较关注、适合中国企业发展的部分，并邀请了多位 Google Cloud 资深行业专家，组织三期 “Google Cloud Next ’20 精选课” 线上直播系列活动。9月10日-24日每周四15:00-16:00精选课程准时直播，敬请关注！`,
    list: [
      {
        title: '构建行业未来——深化游戏、媒体、零售、制造行业转型',
        info: 'Google Cloud 简化游戏复杂性、Google Cloud 加速多媒体用户触达、Google Cloud 助力智慧零售、Google Cloud 助力制造业数字化转型',
        time: '9月10日',
        link: 'http://cloudonair.vhall.com/live/detail/id/140.html',
        hrColor: '#D9372A'
      },
      {
        title: '加速基础设施、应用现代化建设',
        info: 'Google Cloud 简化游戏复杂性、Google Cloud 加速多媒体用户触达、Google Cloud 助力智慧零售、Google Cloud 助力制造业数字化转型',
        time: '9月17日',
        link: 'http://cloudonair.vhall.com/live/detail/id/141.html',
        hrColor: '#33A853'
      },
      {
        title: '利用云计算挖掘数据价值',
        info: 'Google Cloud 数据库现代化之路、Google Cloud 数据分析战略和产品更新、Google Cloud 利用最新的AI技术构建企业级的AI业务',
        time: '9月24日',
        link: 'http://cloudonair.vhall.com/live/detail/id/142.html',
        hrColor: '#FABB06'
      }
    ]
  },

  news: {
    title: '新闻速递',
    subtitle: '为你带来大会的最新动态与技术干货',
    list: [
      {
        img: 'https://static001.geekbang.org/resource/image/a0/34/a0ff8da8fb1186dd068a13f71ayya534.png',
        type: 'Cloud AI',
        title: `机器学习无忧入门指南`,
        info: '本文中将为您介绍一些深受作者喜爱的 Google Cloud AI 工具，并且分享快速构建由 AI 驱动的应用程序的小窍门。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/86JKyfEfhE0m47A2MbED'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/88/c7/887062a0d2118245261bb94yy625e2c7.png',
        type: 'Cloud AI',
        title: `MLOps 基础的主要要求`,
        info: '我们的目标是让机器学习表现得更类似于计算机科学，因此能够更加高效、快捷地部署，很高兴可以为您的业务带来效率和速度。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/LlzTaIum8ciZgpq9z3Rv'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/01/47/01b016e814eea61d16de905f00265847.png',
        type: '应用现代化改造',
        title: `GKE 最佳实践：设计和构建高可用性集群`,
        info: '当考虑 GKE 集群的高可用性时，第零日往往被忽视，因为很多人都认为中断和维护是后续第二日运营的组成部分。而实际上，在部署工作负载之前，有必要仔细规划您的 GKE 集群的拓扑结构和配置。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/kIa3JMG2sJuGOKNLtytl'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/d5/79/d5f4bca1a5ee7463ab9ab2c8e883fb79.png',
        type: '应用现代化改造',
        title: `GKE 最佳实践：通过 Ingress 和 Service 公开 GKE 应用程序`,
        info: '我们将全面介绍在 GKE 中公开应用程序时应当考虑的不同因素，详解这些因素会如何影响应用程序公开，并且重点阐述针对不同的需求将使用哪个最适合的网络解决方案。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/LlzTaIum8ciZgpq9z3Rv'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/85/2b/85cd1a204b972f5bf2a294e06e4db22b.png',
        type: '应用现代化改造',
        title: `Anthos 强势崛起 —— 更易用、能够处理更多工作负载`,
        info: '我们的许多客户选择 Anthos 的原因在于其“服务至上”的理念。借助 Anthos，您可以实现服务自动化，这使您能够主动进行监控并及早发现问题。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/Ly3zBJV8vRQgighFJ7l6p'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/71/f4/71eaa5e8b6459db9dbf398e204b2bff4.png',
        type: '数据管理与数据库',
        title: `为您的下一个项目考虑 Cloud Spanner 的三大原因`,
        info: '借助可靠的数据库，您能够实现应用程序可扩展性，并确保数据的持久性和一致性以及服务可用性和更高的系统支持能力。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/DXIbRi7GsvGVmSjZI0D3'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/67/46/67ebcc2cd5b0dc4164fdfa545094fd46.png',
        type: '基础架构',
        title: `Google Cloud Next ’20: OnAir-为所有应用程序提供基础架构`,
        info: '详解谷歌云全球基础架构的强大功能，让你轻松应对各种超负载工作。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/32Z8HF68jXUSOPADv3qk'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/de/e2/de5a6af42e7ee4d93bae4a96fa6945e2.png',
        type: '基础架构',
        title: 'Compute Engine 详解：选择正确的虚拟机系列和类型',
        info: '为应对工作负载所使用的云计算资源是否是最佳选择？本文从多个维度教你该如何充分利用计算引擎',
        link: 'https://www.infoq.cn/zones/google/cloud/article/mo1bpA5WLOfXOyaUHdMg'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/d8/1a/d863feaf9209f13c61d45dcebee3d31a.png',
        type: '数据分析',
        title: '利用 BigQuery Omni 对您的数据进行多云分析',
        info: 'BigQuery Omni是我们对多云的持续创新和承诺的扩展，无论您将数据存储在何处，都能为您带来最佳的分析和数据仓库技术。 ',
        link: 'https://www.infoq.cn/zones/google/cloud/article/Op7RKw90h1FwfiTqCf66'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/0a/ee/0a0f59f13fbf2146960yyf8cd8497bee.png',
        type: '数据分析',
        title: '向 BigQuery 提问并通过 Data QnA 获得即时答案',
        info: '数据QnA将帮助您的业务用户获得其分析查询的答案，而不会给商业智能（BI）团队造成负担。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/lMUdKlxrL8N39LDAJ30q'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/e5/a9/e548ec48ddbb5095062062097aeec8a9.png',
        type: '数据管理与数据库',
        title: '面向亚洲和欧洲新的 Spanner 多区域配置',
        info: '更多的区域分布可让Spanner在确保高可用性的同时，为全球用户提供高质量的客户体验。。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/LOu4XZLtZHN6IqhC2788'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/65/8c/65fe1ea9fac2b0bb332db6f61724fd8c.png',
        type: 'Cloud AI',
        title: '利用 Google Cloud AutoML 改进客户反馈管理',
        info: '将AI集成到客户反馈管理流程中可以使重复的任务自动化，可以使时间使用效率最大化。',
        link: 'https://www.infoq.cn/zones/google/cloud/article/JEHHWYXsCzIRduYbQxlu'
      }
    ]
  },

  videos: {
    title: '精选视频',
    subtitle: '为你展示出最具观看价值的大会视频',
    typeList: [
      {
        name: '产业洞察&生产力与协作',
        id: 1
      },
      {
        name: '基础架构',
        id: 2
      },
      {
        name: '安全',
        id: 3
      },
      {
        name: '数据分析',
        id: 4
      },
      // {
      //   name: '数据管理与数据库',
      //   id: 5
      // },
      {
        name: '应用现代化改造',
        id: 6
      }
      // {
      //   name: 'Cloud AI',
      //   id: 7
      // },
      // {
      //   name: '业务应用平台',
      //   id: 8
      // }
    ],
    videosList: [
      {
        img: 'https://static001.geekbang.org/resource/image/17/01/17c549e128043db1c706b79ddebc5001.jpg',
        typeId: 6,
        link: 'https://b23.tv/aMMWAL',
        title: '使用 Istio 和 ASM 建构可扩展全球的服务'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/a0/1b/a02be8caa32f293d01a7dc7ce5a4431b.jpg',
        typeId: 6,
        link: 'https://b23.tv/6w161R',
        title: '将虚拟机器工作负载整合至 Anthos Service Mesh'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/e6/4e/e65d2c55d7719914e74d3218deab244e.png',
        typeId: 2,
        link: 'https://b23.tv/agLuxn',
        title: 'Google Cloud 网络安全性新功能'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/80/ac/804b8ac48d37ceacefa961c496655eac.png',
        typeId: 2,
        link: 'https://b23.tv/B44CdI',
        title: '使用Traffic Director构建企业级Service Mesh'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/92/70/921db9109c28b33cb4c4fb288de82270.png',
        typeId: 2,
        link: 'https://b23.tv/oXHvvw',
        title: '使用GCP#TwitterEng为数百万用户提供混合式的网络'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/eb/a8/ebb47927e709982372e62f42cf5yyda8.png',
        typeId: 1,
        title: '将服务涵盖所有使用者：强化安全和隐私以促进协作进行',
        link: 'https://b23.tv/lpGSWF'
      },
      {
        img: 'https://static001-test.geekbang.org/resource/image/82/a9/826cca09d9f951ffe0c57f227c9da9a9.png',
        typeId: 1,
        title: '用 G Suite 沟通：Gmail、Chat、Meet 和更多功能的未来',
        link: 'https://b23.tv/N4wbk8'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/5e/08/5ec29eee43577637a6786b9d9859ff08.jpg',
        typeId: 3,
        title: '利用云端安全中心控制安全性',
        link: 'https://b23.tv/KMSbG7'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/a5/81/a58cb3448b0dd8eaa64988d3b2c06b81.jpg',
        typeId: 3,
        title: '在混合式环境中管理高敏感度的资料',
        link: 'https://b23.tv/KNqnvo'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/97/cb/9732ayye5ca75d8a737febd41182dccb.jpg',
        typeId: 3,
        title: '如何透过 Google Cloud Armor 保护网站和应用程程式',
        link: 'https://b23.tv/4woCOB'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/f0/39/f00e85638d70ef73facb77ae2a1e0739.jpg',
        typeId: 4,
        title: 'Google Cloud 现代化资料仓储系统 BigQuery 有什么新功能',
        link: 'https://b23.tv/pQ3qxi'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/c0/e1/c02ee0770de177a56ec5822eb2a5f8e1.jpg',
        typeId: 4,
        title: '美国职棒大联盟 (MLB) 的资料仓储现代化',
        link: 'https://b23.tv/63rCIS'
      },
      {
        img: 'https://static001.geekbang.org/resource/image/78/1a/78d589b669f12695b341d3743b2e371a.jpg',
        typeId: 4,
        title: '智慧分析：深度分析路径图',
        link: 'https://b23.tv/ivLZiK'
      }
    ]
  }
}
